var map = {
	"./alipay.svg": "d730",
	"./amex.svg": "348d",
	"./aura.svg": "0487",
	"./banescard.svg": "421b",
	"./default.svg": "34a1",
	"./diners.svg": "7058",
	"./discover.svg": "1e09",
	"./elo-payment-link.svg": "3e9d",
	"./elo.svg": "509e",
	"./hiper.svg": "6538",
	"./hipercard.svg": "c45a",
	"./jcb.svg": "b339",
	"./maestro.svg": "26c8",
	"./mastercard.svg": "9eb3",
	"./mir.svg": "d9cd",
	"./paypal.svg": "9c83",
	"./sodexo.svg": "26b0",
	"./unionpay.svg": "30b5f",
	"./visa.svg": "22c4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e9b";